import { AtlasForm } from '@/features/factory/subfactories/AtlasForm'

/** Sub-route /factory/atlas — wraps the Atlas form component. */
export function AtlasPage() {
  return <AtlasForm />
}
